var cilWindowMaximize = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M472,48H40.335a24.027,24.027,0,0,0-24,24V456a24.027,24.027,0,0,0,24,24H472a24.027,24.027,0,0,0,24-24V72A24.027,24.027,0,0,0,472,48Zm-8,32v71.981L48.335,151.49V80ZM48.335,448V183.49L464,183.981V448Z' class='ci-primary'/>"];

export { cilWindowMaximize };

